import React from "react"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W3",
  fontSize: "20px",
  lineHeight: 1.75,
  letterSpacing: "normal",
  color: "#333",
  fontWeight: "700",
  marginBottom: 0,
}))

const TextInformationText = (props) => {
  return <StyledTypography component="h3">{props.children}</StyledTypography>
}

export default TextInformationText
